export default __webpack_public_path__ + "static/media/generic_emptyInfonews.0841d835.png";